<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    @if(isNewUser){<h3>Create New User</h3>}
    @if(!isNewUser){<h3>Update User</h3>}
    <hr />
    <form [formGroup]="newUserForm" (ngSubmit)="createUser(newUserForm.value)" autocomplete="off">
      <div class="container">
        @if(!isUserFormValid()){
        <div class="row text-danger">
          <label> {{errorMessage}}</label>
        </div>
        }
        <div class="row">
          <div class="form-group col-md-12">
            <label class="form-label" for="email">Email address:</label>
            @if(isNewUser){<input type="email" class="form-control" id="email" name="Email" placeholder="Enter email" formControlName="Email">}
            @if(!isNewUser){<h2>{{User.Email}}</h2>}
            @if(newUserForm.value.Email.invalid&&newUserForm.value.Email.touched){<em class="text-danger">Required</em>}
            @if(emailInUse){<em class="text-danger">This email already used!</em>}
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label class="form-label" for="firstName">First name:</label>
            <input type="text" class="form-control" id="firstName" placeholder="Enter first name" formControlName="FirstName">
            @if(newUserForm.value.FirstName.invalid&&newUserForm.value.FirstName.touched){<em class="text-danger">Required</em>}
          </div>
          <div class="form-group col-md-6">
            <label class="form-label" for="lastName">Last name:</label>
            <input type="text" class="form-control" id="lastName" placeholder="Enter last name" formControlName="LastName">
            @if(newUserForm.value.LastName.invalid&&newUserForm.value.LastName.touched){<em class="text-danger">Required</em>}
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label class="form-label" for="tel">Tel:</label>
            <input type="text" class="form-control" id="tel" placeholder="Enter telphone  number" formControlName="Tel">
            @if(newUserForm.value.Tel.invalid&&newUserForm.value.Tel.touched){<em class="text-danger">Required</em>}
          </div>
          <div class="form-group col-md-6">
            <label class="form-label" for="Site">Site</label>
            <select formControlName="Site" id="Site" class="form-control input-md m-bot15" (change)="onSiteChange($event)">
              @for(site of Sites; track site.SiteId) {
              <option [value]="site.SiteId">
                {{site.SiteName}}
              </option>
              }
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <ul class="list-unstyled">
              <li>
                <label class="form-label icheck-label" for="canViewResults">Results Viewer?</label>
                <input type="checkbox" id="canViewResults" formControlName="CanViewResults" class="icheckbox_square-blue">
                @if(newUserForm.value.CanViewResults.invalid&&newUserForm.value.CanViewResults.touched){<em class="text-danger">Required</em>}
              </li>
              <li>
                <label class="icheck-label form-label" for="canOrderKits">Can order kits?</label>
                <input type="checkbox" id="canOrderKits" formControlName="CanOrderKits" class="icheckbox_square-blue">
                @if(newUserForm.value.CanOrderKits.invalid&&newUserForm.value.CanOrderKits.touched){<em class="text-danger">Required</em>}
              </li>
              <li>
                <label class="icheck-label form-label" for="enableTFA">Enable Two Factor Authentication?</label>
                <input type="checkbox" id="enableTFA" formControlName="TwoFactorEnabled" class="icheckbox_square-blue">
                @if(newUserForm.value.TwoFactorEnabled.invalid&&newUserForm.value.TwoFactorEnabled.touched){<em class="text-danger">Required</em>}
              </li>
              <li>
                <label class="icheck-label form-label" for="canRequest">Can Request?</label>
                <input type="checkbox" id="canRequest" formControlName="CanRequest" class="icheckbox_square-blue" (click)="onCanRequestChange()">
                @if(newUserForm.value.CanRequest.invalid&&newUserForm.value.CanRequest.touched){<em class="text-danger">Required</em>}
              </li>
              @if(isCanSeeAllSiteResultsEnabled()){
              <li>
                <label class="icheck-label form-label" for="canSeeAllSiteResults">Can View All Site Results?</label>
                <input type="checkbox" id="canSeeAllSiteResults" formControlName="CanSeeAllSiteResults" class="icheckbox_square-blue" (click)="onCanSeeAllSiteResultsChange()">
                @if(newUserForm.value.CanSeeAllSiteResults.invalid&&newUserForm.value.CanSeeAllSiteResults.touched){<em class="text-danger">Required</em>}
              </li>
              }
            </ul>
          </div>
          <!--@if(User.Site == 2){ -- commented out for CSL
            <div class="form-group col-md-6">
              <label class="form-label" for="clin">Clinician:</label>
              <input type="text" class="form-control" id="clin" placeholder="Enter clin code" formControlName="Clinician">
              @if(newUserForm.value.Clinician.invalid&&newUserForm.value.Clinician.touched){<em class="text-danger">Max 10</em>}
            </div>
            }-->
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <h2> Sources</h2>
          </div>
          <div class="form-group col-md-6 no-left-padding">
            <mat-form-field class="example-full-width">
              <input type="text"
                     [formControl]="myControl"
                     matInput
                     [matAutocomplete]="auto"
                     class="form-control" />
              <mat-autocomplete #auto="matAutocomplete">
                @for(source of Sources; track source.Id) {
                <mat-option [value]="source.SourceCode" (onSelectionChange)="selectSource($event, source)">
                  {{ source.SourceCode }} - ({{source.Site}})
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-group col-md-6">
            <button type="button" (click)="addSource()" [disabled]="!canAddSource(selectedSource)" class="btn btn-sm" [ngClass]="{'btn-primary':canAddSource(selectedSource),'btn-warning':!canAddSource(selectedSource)}">
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>

        <div class="row">

          <table class="table">
            @for(source of User.Sources; track source.Id){
            <tr>
              <td>
                <div class="row source-header">
                  <div class="col-md-10 row-source">{{source.SourceCode}}</div>
                  <div class="col-md-2 row-source">
                    <!--<input type="button" value="Remove" (click)="removeSource(source)" class="btn-default  btn-danger" />-->

                    <button (click)="removeSource(source)" class="btn btn-sm btn-info" type="button">
                      <i class="fa fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            }
          </table>

        </div>
        <hr />
        <div class="row">
          <div class="form-group">
            <button type="submit" class="btn btn-success btn-block" [disabled]="!isUserFormValid()">Submit</button>

          </div>
        </div>
        <div class="row">
          <div class="form-group">

            <button type="button" class="btn btn-success btn-block" (click)="cancel()">Cancel</button>
          </div>
        </div>

      </div>
    </form>
  </section>
</section>
